// 上周送礼前三国家
import React from 'react'
import './index.less'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  render() {
    const { list, lang } = this.props
    return (
      <div className='last-week'>
        <div className='hd'>
          <h2>{lang.last_week_global_star}</h2>
        </div>
        <div className='bd'>
          {/* 背景图层 */}
          <div className="bd-bg">
            <div className="last-week-bg">
              <img src="/img/activity/national-star/img_box_last_week_bg@2x.png" />
            </div>
            <div className="bd-bg-list">
              <div className="top">
                <img src="/img/activity/national-star/img_box_bg_frame_top@2x.png" />
              </div>
              <div className="min">
                <img src="/img/activity/national-star/img_box_bg_frame_mid@2x.png" />
              </div>
              <div className="bottombottom">
                <img src="/img/activity/national-star/img_box_bg_frame_bot@2x.png" />
              </div>
            </div>
          </div>
          {/* 背景图层 */}
          <div className="week-contant">
            <div className="icon-wrap">
              {
                list &&
                list.map((item, index) => {
                  return (<div
                    className={`
                      icon-item
                      ${index === 0 ? 'one' : ''}
                      ${index === 1 ? 'two' : ''}
                      ${index === 2 ? 'three' : ''}
                    `}
                    key={item.countryIcon}
                  >
                    <img src={item.countryIcon} />
                  </div>)
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/last-week/index.js